module.exports = __webpack_public_path__ + "media/images/avatar-3-2b7461d1a0927a1203b93a927fa7783e.jpg";